<script setup>
/**
 * ActivitiesMock — the event's activity catalogue as crisp vector UI.
 * Only shipped modules appear (polls, quiz, Q&A, word cloud).
 * Decorative; stand-in until retina captures replace it.
 */
const ROWS = [
  { name: 'Session Q&A', desc: 'Questions du public, modération en direct', bg: '#e84393', letter: '?', live: true },
  { name: 'Quiz', desc: 'Testez les connaissances, résultats immédiats', bg: '#00b894', letter: '✦', live: false },
  { name: 'Sondage', desc: 'Votes en salle, satisfaction, NPS', bg: '#6d4fc2', letter: '▥', live: true },
  { name: 'Nuage de mots', desc: 'Les idées de la salle, en un coup d’œil', bg: '#e8a34d', letter: '☁', live: false }
]
</script>

<template>
  <div class="bg-white" aria-hidden="true">
    <div class="px-5 pt-4 pb-3 border-b border-slate-100">
      <div class="flex items-center justify-between">
        <div>
          <div class="text-[15px] font-semibold text-slate-900">Activités</div>
          <div class="text-[11px] text-slate-400">Bifrost Tech Days · Salle Midgard</div>
        </div>
        <span class="bg-[#6d4fc2] text-white rounded-md px-3 py-1.5 text-[11px] font-medium">+ Créer</span>
      </div>
      <div class="mt-3 flex items-center gap-2 border border-slate-200 rounded-lg px-3 py-2 text-[12px] text-slate-400">
        <svg viewBox="0 0 20 20" fill="none" class="w-3.5 h-3.5"><circle cx="9" cy="9" r="6" stroke="currentColor" stroke-width="1.6" /><path d="M13.5 13.5 17 17" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" /></svg>
        Rechercher une activité
      </div>
    </div>

    <div class="divide-y divide-slate-100">
      <div v-for="(row, i) in ROWS" :key="i" class="flex items-center gap-3.5 px-5 py-3.5">
        <span class="w-9 h-9 rounded-lg flex items-center justify-center text-white text-[15px] shrink-0" :style="`background:${row.bg}`">
          {{ row.letter }}
        </span>
        <div class="min-w-0 flex-1">
          <div class="flex items-center gap-2">
            <span class="text-[13px] font-semibold text-slate-900">{{ row.name }}</span>
            <span v-if="row.live" class="inline-flex items-center gap-1 text-[9.5px] font-medium text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-full px-1.5 py-px">
              <span class="w-1 h-1 rounded-full bg-emerald-500"></span> En cours
            </span>
          </div>
          <div class="text-[11px] text-slate-400 truncate">{{ row.desc }}</div>
        </div>
        <span class="text-[11px] text-slate-500 border border-slate-200 rounded-md px-2.5 py-1 shrink-0">Résultats</span>
      </div>
    </div>

    <div class="flex items-center justify-between px-5 py-2.5 bg-slate-50 border-t border-slate-100 text-[11px] text-slate-500">
      <span dir="ltr">50 participations aujourd'hui</span>
      <span class="text-emerald-600">Résultats diffusés en direct</span>
    </div>
  </div>
</template>
